import React from "react";
import "./StrategyFramework.css";
import advisoryImage from "../../../images/advisoryImage.png";
import frameworkImage from "../../../images/framework.png";
import marketIcon from "../../../images/market.png";
import fundIcon from "../../../images/fund.png";
import frameworkIcon from "../../../images/framework.png";
import advisoryIcon from "../../../images/advisory.png";
import rightIcon from "../../../images/right.png";

const pillarsTop = [
  {
    id: 1,
    icon: rightIcon,
    title: "Build The Right Company",
    text: "We help founders build skills ontologies, knowledge graphs, AI reasoning layers, performance-based assessment systems, and skills wallet infrastructure. This creates defensible IP — not commoditized content.",
  },
  {
    id: 2,
    icon: marketIcon,
    title: "Speed To Market",
    text: "We provide a Learning Experience Platform, skills taxonomy mapping, AI interview modules, career readiness workflows, and fractional CTO, CMO, and CPO resources. Goal: MVP live fast. Validate. Iterate.",
  },
  {
    id: 3,
    icon: fundIcon,
    title: "Fundraising & Governance",
    text: "We help companies move from idea to fundable infrastructure — with data moat strategy, ontology IP protection, enterprise-ready governance, and repeatable revenue models.",
  },
];

const pillarsBottom = [
  {
    id: 4,
    icon: frameworkIcon,
    title: "Operating Framework",
    text: "Our playbooks cover skills-based sales motion, enterprise HR integration, hiring marketplace economics, and subscription and usage models. Highly successful companies prioritize minimizing mistakes and maintain a substantial Not-To-Do List — because it's more crucial than any To-Do List.",
  },
  {
    id: 5,
    icon: advisoryIcon,
    title: "Talent & Advisory Network",
    text: "We connect portfolio companies to employers, workforce boards, government agencies, industry regulators, and higher education partners.",
  },
];

const StrategyFramework = () => {
  return (
    <section className="strategy-framework-section">
      <div className="container">
        <div className="strategy-framework-header text-center">
          <p className="strategy-framework-label">FRAMEWORK</p>
          <h2 className="strategy-framework-title">
            Our Five-Pillar Build Framework
          </h2>
        </div>

        <div className="strategy-framework-image-wrap">
          <img
            src={advisoryImage}
            alt="Our five-pillar build framework"
            className="img-fluid strategy-framework-image"
          />
        </div>

        <div className="strategy-framework-top-row">
          <div className="row g-0">
            {pillarsTop.map((pillar, index) => (
              <div
                className={`col-lg-4 col-md-6 ${
                  index === 2 ? "mx-md-auto" : ""
                }`}
                key={pillar.id}
              >
                <div className="strategy-framework-card strategy-framework-card-top">
                  <div className="strategy-framework-icon">
                    <img src={pillar.icon} alt={pillar.title} />
                  </div>

                  <h3 className="strategy-framework-card-title">
                    {pillar.id}. {pillar.title}
                  </h3>

                  <p className="strategy-framework-card-text">{pillar.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="strategy-framework-bottom-row">
          <div className="row g-0 justify-content-center">
            {pillarsBottom.map((pillar) => (
              <div className="col-lg-6 col-md-6" key={pillar.id}>
                <div className="strategy-framework-card strategy-framework-card-bottom">
                  <div className="strategy-framework-icon">
                    <img src={pillar.icon} alt={pillar.title} />
                  </div>

                  <h3 className="strategy-framework-card-title">
                    {pillar.id}. {pillar.title}
                  </h3>

                  <p className="strategy-framework-card-text">{pillar.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StrategyFramework;